import { BASE_API_URL } from '../constants'
import { ax } from '../utils/axios/axios'

interface Options {
  query: string,
  locationId?: string,
}

export const apiBinderTypeSearch = ({
  query,
  locationId,
}: Options) => {
  const params: any = {
    search: query,
  }
  
  if (locationId) {
    params.Location_ID = locationId
  }

  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/ref/spraybindertypes`,
    params
  }
  return ax(options)
}